import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
} from '../../constants/CommonUtil';
import {
    FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_FAILURE,
    FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_SUCCESS,
} from '../../redux/modules/patientPortalEncounterSync/patientPortalEncounterSync-actions';
import { generatePatientPortalEncounterSyncSearchConstruct } from '../../containers/PatientSearchContainer/PatientPortalEncounterSyncDialogUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';

function* fetchPatientPortalEncounterSyncWorker(action) {
    try {
        const {
            api,
            page,
            size,
            filters,
            seekParams,
            seekDirection,
        } = action;
        const searchConstruct = generatePatientPortalEncounterSyncSearchConstruct(filters);
        const encodedSeekParams = seekParams ? encodeURIComponent(JSON.stringify(seekParams)) : null;
        let apiWithParams = `${api}?size=${size}&direction=${seekDirection || 'FORWARD'}`;
        if (encodedSeekParams) {
            apiWithParams += `&seekParams=${encodedSeekParams}`;
        }
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.post, apiWithParams, searchConstruct);
        yield put({
            type: FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_SUCCESS,
            data: {
                ...(response.data || {}),
            },
            page,
            size,
            filters,
            seekParams,
            seekDirection,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Fetching patient portal encounter sync entries failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_FAILURE, data: {} });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export default fetchPatientPortalEncounterSyncWorker;
